
import { Component, Vue, } from 'vue-property-decorator';
import { Store, } from '~/apps/account/store';
import FeedbackBox from '~/components/feedback-box/feedback-box.vue';
import HeaderText from '~/components/header-text/header-text.vue';
import LandingLink from '~/components/landing-link/landing-link.vue';
import LoginContentTile from '~/components/self-serve/login-content-tile/login-content-tile.vue';
import LoginForm from '~/components/self-serve/login-form/login-form.vue';
import SectionContainer from '~/components/self-serve/section-container/section-container.vue';
import UnauthedNav from '~/components/unauthed-nav/unauthed-nav.vue';

@Component({
	components: {
		HeaderText,
		LoginForm,
		SectionContainer,
		FeedbackBox,
		UnauthedNav,
		LandingLink,
		LoginContentTile,
	},
	metaInfo: {
		title: 'Your Account - Southern Water',
		meta: [
			{
				name: 'description',
				content: 'Southern Water Your Account is easy, secure and lets you take control to manage your water and wastewater account online. Log in to Your Account.',
			},
		],
	},
})
export default class Login extends Vue {
	userPassword = '';
	userEmail = '';
	getLayout = document.querySelector('.layout');

	logo = Store.getters.getGlobalConfigValue('SouthernWaterLogo');
	logoWidth = Store.getters.getGlobalConfigValue('SouthernWaterLogoWidth');
	logoHeight = Store.getters.getGlobalConfigValue('SouthernWaterLogoHeight');
	get logoDetails() {
		return Store.getters.getGlobalConfigValue('SouthernWaterLogoDetails');
	}

	contactUsLocation = Store.getters.getGlobalConfigValue('ContactUsLocation');

	async mounted() {
		this.getLayout?.classList.add('login-wrapper');
		try {
			const currentMessage = Store.state.message;
			await Store.dispatch.resetAll();
			if (currentMessage !== null) {
				Store.commit.showMessage(currentMessage);
				Store.commit.prepareAvailableMessage();
			}
		} catch {
			location.reload();
		}
	}

	beforeDestroy() {
		this.getLayout?.classList.remove('login-wrapper');
	}

	get currentMessage() {
		const currentMessage = Store.getters.availableMessage;
		if (currentMessage) {
			Store.commit.makeMessageAsRead();
		}

		return currentMessage;
	}

	get currentMessageComponentWrapper() {
		const currentMessage = this.currentMessage?.body;
		if (currentMessage === null || typeof currentMessage !== 'string') {
			return 'div';
		}

		if (currentMessage.trimStart().startsWith('<')) {
			return 'div';
		}

		return 'p';
	}

	loginContentTiles = Store.state.customContent.loginContentTiles;

	get loginPromoBanner() {
		return Store.state.customContent.loginPromoBanner;
	}
}
